module.exports = __webpack_public_path__ + "static/media/Choose_sB.bf59ea45.png";